export function cleanText (value: string): string {
  return value.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim()
}

export function firstText (selectors: string[], root: ParentNode = document): string {
  for (const selector of selectors) {
    const value = root.querySelector<HTMLElement>(selector)?.textContent
    if (!value) continue

    const cleaned = cleanText(value)
    if (cleaned) return cleaned
  }

  return ''
}

export function readMeta (...keys: string[]): string {
  for (const key of keys) {
    const attr = key.startsWith('og:') ? 'property' : 'name'
    const value = document.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`)?.content
    if (value) return cleanText(value)
  }

  return ''
}

export function normalizeDescriptionText (value: string): string {
  return value
    .replace(/\u00a0/g, ' ')
    .replace(/\r\n?/g, '\n')
    .split('\n')
    .map((line) => line.trim())
    .filter((line, index, arr) => line.length > 0 || (index > 0 && arr[index - 1].length > 0))
    .join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
}

export function parseDescriptionFromHtml (html: string): string {
  const prepared = html
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n\n')
    .replace(/<\/div>/gi, '\n')

  const temp = document.createElement('div')
  temp.innerHTML = prepared
  temp.querySelectorAll('script, style').forEach((el) => el.remove())

  return normalizeDescriptionText(temp.textContent || '')
}

const MONTH_MAP: Record<string, string> = {
  jan: '01', january: '01',
  feb: '02', february: '02',
  mar: '03', march: '03',
  apr: '04', april: '04',
  may: '05',
  jun: '06', june: '06',
  jul: '07', july: '07',
  aug: '08', august: '08',
  sep: '09', sept: '09', september: '09',
  oct: '10', october: '10',
  nov: '11', november: '11',
  dec: '12', december: '12'
}

export function normalizeDate (raw: string): string {
  const value = cleanText(raw)
  if (!value) return ''

  // YYYY-M-D with various separators: - / . 年 月 (supports Chinese/Japanese/ISO)
  const ymd = value.match(/(\d{4})[/.\-年\s]+(\d{1,2})[/.\-月\s]+(\d{1,2})日?/)
  if (ymd) return `${ymd[1]}-${ymd[2].padStart(2, '0')}-${ymd[3].padStart(2, '0')}`

  // D Month YYYY (e.g. "1 January 2024")
  const dmy = value.match(/(\d{1,2})\s+([A-Za-z]{3,9})\s+(\d{4})/)
  if (dmy) {
    const month = MONTH_MAP[dmy[2].toLowerCase()]
    if (month) return `${dmy[3]}-${month}-${dmy[1].padStart(2, '0')}`
  }

  // Month D, YYYY (e.g. "January 1, 2024")
  const mdy = value.match(/([A-Za-z]{3,9})\s+(\d{1,2}),?\s+(\d{4})/)
  if (mdy) {
    const month = MONTH_MAP[mdy[1].toLowerCase()]
    if (month) return `${mdy[3]}-${month}-${mdy[2].padStart(2, '0')}`
  }

  return value
}
